import { Flex } from "orcs-design-system";
import GroupTypeBadge from "src/components/Badge/GroupTypeBadge";
import { TreeNodeLabel } from "src/shared/TreeViewNext";

type GroupNode = {
  id?: string;
  name?: string | undefined;
  isPlaceholder?: boolean;
  loading?: boolean;
  group?: {
    id?: string;
    type?: string;
    isHidden?: boolean;
    [key: string]: unknown;
  };
  [key: string]: unknown;
};

type GroupsTreeHeaderProps = {
  node: GroupNode;
  groupTypes?: Record<string, unknown>;
};

const GroupsTreeHeader = ({ node, groupTypes }: GroupsTreeHeaderProps) => {
  const { group } = node;

  return (
    <Flex alignItems="center" width="100%" gap="xs" style={{ minWidth: 0 }}>
      <TreeNodeLabel node={node} />
      {group && groupTypes && (
        <GroupTypeBadge
          group={group}
          groupTypes={groupTypes as never}
          style={{ flexShrink: 0 }}
        />
      )}
    </Flex>
  );
};

export default GroupsTreeHeader;
